/**
 * Session scope utility for isolating portal sessions from the main app.
 *
 * Rules:
 *  - A user may be logged into exactly ONE portal OR the main application.
 *  - Logging into the main app clears any active portal session.
 *  - Logging into a portal clears any previous app/portal session.
 */

const SESSION_SCOPE_KEY = "ezron_session_scope";
const ACTIVE_PORTAL_KEY = "ezron_active_portal";

/** Set the session scope to a specific portal. */
export function setPortalSession(shareId) {
  sessionStorage.setItem(SESSION_SCOPE_KEY, "portal");
  sessionStorage.setItem(ACTIVE_PORTAL_KEY, shareId);
}

/** Set the session scope to the main application. */
export function setAppSession() {
  sessionStorage.setItem(SESSION_SCOPE_KEY, "app");
  sessionStorage.removeItem(ACTIVE_PORTAL_KEY);
}

/** Return the current scope: "portal", "app", or null. */
export function getSessionScope() {
  return sessionStorage.getItem(SESSION_SCOPE_KEY);
}

/** Return the shareId of the active portal (only meaningful when scope is "portal"). */
export function getActivePortalShareId() {
  return sessionStorage.getItem(ACTIVE_PORTAL_KEY);
}

/** Clear all session scope data (used on logout). */
export function clearSessionScope() {
  sessionStorage.removeItem(SESSION_SCOPE_KEY);
  sessionStorage.removeItem(ACTIVE_PORTAL_KEY);
}

/** True when the user is in a portal session. */
export function isPortalSession() {
  return getSessionScope() === "portal";
}

/** True when the user is in a main-app session. */
export function isAppSession() {
  return getSessionScope() === "app";
}
